const { trim } = require("lodash");
const { MIN_LENGTH_PHONE_NUMBER } = require("../../common/constants");

module.exports.isEmpty = (value) => !trim(value);
module.exports.isPhoneNumber = (value) =>
  value.replace(/\D/g, "").length >= MIN_LENGTH_PHONE_NUMBER;
module.exports.isValidEmail = (value) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value
  );
module.exports.isValidName = (value) => /^[a-zA-Z]+$/.test(value);



// WEBPACK FOOTER //
// ./common/validations/rules.js